export const POST_MESSAGE_ACTIONS = {
  PLATFORM_ALERT: 'ALERT',
  PLATFORM_SYNC_USER: 'SYNC_USER',
  PLATFORM_SSO_EXPIRED_TOKEN: 'EXPIRED_TOKEN'
};

export const ONBOARDING_SESSION_KEY = 'X-Onboarding-Session-Key';
export const MOBILE_SESSION_KEY = 'OpenInMobile';
export const UCODE_KEY = 'ucode';

// event tracking
export const SYSTEM = 'app_idverify' as const;